/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import _ from 'lodash';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import * as ActionTypes from './actionsTypes';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';

export const dispatchPlanType = (data) => ({
  type: ActionTypes.GET_PLAN_TYPE_DATA,
  payload: data,
});

export const getPlanTypeValues = () => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch(dispatchPlanType(response.data));
    })
    .catch(() => {
      dispatch(setLoading(false));
      dispatch(dispatchPlanType([]));
    });
};

// API to get Reabte Program List
export const getRebateProgrameList = (value) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      dispatch(setLoading(false));
      return response.data.data;
    })
    .catch(() => {
      dispatch(setLoading(false));
    });
};

export const setSearchInput = (data) => ({
  type: ActionTypes.SET_SELECTED_ZERO_URA,
  payload: data,
});

// Loader
export const setLoading = (value) => ({
  type: ActionTypes.IS_LOADING_ZERO_URA,
  isLoading: value,
});

// To get the defaut selection on the req screen when reopening the req screen
export const refreshOutstandingDispAfterNumOfDays = () => ({
  type: ActionTypes.REFRESH_OUTSTANDING_DISPUTES_AFTER_NUM_OF_DAYS,
  payload: {},
});

export const refreshOutstandingDispAfterNumOfDaysDisplay = () => ({
  type: ActionTypes.REFRESH_OUTSTANDING_DISPUTES_AFTER_NUM_OF_DAYS_DISPLAY,
  payload: {},
});
// This action show error message for 5 sec for no contract exists
export const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
  //   dispatch(setSearchInput({ errors: [] }));
  // }, 5000);
  dispatch(
    setSearchInput({
      errors: [
        {
          field: 'noData',
          message: NO_DATA,
        },
      ],
    })
  );
};

export const setOutstandingDisputesNumOfDays = (data) => ({
  type: ActionTypes.GET_OUTSTANDING_DISPUTES_NUM_DAYS,
  searchResult: data,
});

// API call for the display screen grid for checked
export const getOustandingDisputesNumDaysResult = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.OUTSTANDING_DISPUTES_NUM_DAYS}`, values)
    .then((response) => {
      dispatch(setLoading(false));
      if (response.data.outstandingDisputesNumberofDaysReportVO.length === 0) {
        dispatch(showNoDataMessage());
      } else {
        return dispatch(
          setOutstandingDisputesNumOfDays(
            response.data.outstandingDisputesNumberofDaysReportVO
          )
        );
      }
    })
    .catch(() => {
      dispatch(setLoading(false));
      dispatch(setOutstandingDisputesNumOfDays([]));
      // return response;
    });
};
export const clearReduxOutStandingDisputesForNumberOfDaysSearchScreen =
  () => (dispatch) => {
    dispatch(setSearchInput({ errors: [] }));
    dispatch(setLoading(false));
    dispatch(dispatchPlanType([]));
    dispatch(refreshOutstandingDispAfterNumOfDays({}));
  };
export const clearReduxOutStandingDisputesForNumberOfDaysDetailsScreen =
  () => (dispatch) => {
    dispatch(setLoading(false));
    dispatch(setOutstandingDisputesNumOfDays([]));
    dispatch(refreshOutstandingDispAfterNumOfDaysDisplay({}));
  };
